import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-auth-logged-out',
  templateUrl: './auth-logged-out.component.html',
  styleUrls: ['./auth-logged-out.component.css']
})
export class AuthLoggedOutComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
    private configService: ConfigService) { }

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.authService.logout();
    } else {
      if (this.configService.config.userManagerSettings.newFlow &&
        this.configService.config.userManagerSettings.newFlow.toString() === "true") {
        this.router.navigate(['/login']);
      } else {
        this.router.navigate(['/']);
      }
    }
  }
}
